import { DomainEntity } from "@/types/domain"

export type DomainFilterOption = {
  value: string
  label: string
}

const ALL_DOMAIN_ID = 0

export const getAllowedDomainOptions = (domains: DomainEntity[] = []): DomainFilterOption[] => {
  const unique = new Map<string, DomainFilterOption>()

  domains.forEach(item => {
    if (!item || item.id === ALL_DOMAIN_ID) return

    const domainValue = item.attributes?.domain?.trim() || ""
    if (!domainValue) return

    if (!unique.has(domainValue)) {
      unique.set(domainValue, {
        value: domainValue,
        label: domainValue,
      })
    }
  })

  return Array.from(unique.values())
}

export const getEnforcedDomainValue = (selectedDomain?: DomainEntity): string => {
  if (!selectedDomain || selectedDomain.id === ALL_DOMAIN_ID) {
    return ""
  }

  return selectedDomain.attributes?.domain?.trim() || ""
}

export const shouldShowDomainFilter = (domains: DomainEntity[] = [], selectedDomain?: DomainEntity): boolean => {
  const enforcedDomain = getEnforcedDomainValue(selectedDomain)
  if (enforcedDomain) return false

  return getAllowedDomainOptions(domains).length > 1
}
